import colorLib from "@kurkle/color"

const COLORS = [
  "#FEC32C",
  "#388BFF",
  "#DA62AC",
  "#82B535",
  "#4dc9f6",
  "#f67019",
  "#f53794",
  "#537bc4",
  "#acc236",
  "#166a8f",
  "#00a950",
  "#58595b",
  "#8549ba",
]

export function color(index: number) {
  return COLORS[index % COLORS.length]
}

export function transparentize(value: string, opacity: number) {
  var alpha = opacity === undefined ? 0.5 : 1 - opacity
  return colorLib(value).alpha(alpha).rgbString()
}

export const CHART_COLORS = {
  "Red / NSW": "rgb(255, 99, 132)",
  "Purple / VIC": "rgb(153, 102, 255)",
  "Green / QLD": "rgb(75, 192, 192)",
  "Pink / SA": "rgb(242, 135, 210)",
  "Orange / WA": "rgb(255, 159, 64)",
  "Blue / TAS": "rgb(54, 162, 235)",
  "Yellow / NT": "rgb(255, 205, 86)",
  "Cyan / ACT": "rgb(162, 224, 238)",
  "Grey / National": "rgb(201, 203, 207)",

  "Regional / NSW": "rgb(200, 41, 60)",
  "Regional / VIC": "rgb(133, 55, 180)",
  "Regional / QLD": "rgb(115, 169, 61)",
  "Regional / SA": "rgb(202, 95, 170)",
  "Regional / WA": "rgb(205, 101, 42)",
  "Regional / TAS": "rgb(13, 63, 193)",
  "Regional / NT": "rgb(215, 167, 0)",
  "Regional / National": "rgb(142, 142, 142)",
}

const NAMED_COLORS = [
  CHART_COLORS["Red / NSW"],
  CHART_COLORS["Purple / VIC"],
  CHART_COLORS["Green / QLD"],
  CHART_COLORS["Pink / SA"],
  CHART_COLORS["Orange / WA"],
  CHART_COLORS["Blue / TAS"],
  CHART_COLORS["Yellow / NT"],
  CHART_COLORS["Cyan / ACT"],
  CHART_COLORS["Grey / National"],

  CHART_COLORS["Regional / NSW"],
  CHART_COLORS["Regional / VIC"],
  CHART_COLORS["Regional / QLD"],
  CHART_COLORS["Regional / SA"],
  CHART_COLORS["Regional / WA"],
  CHART_COLORS["Regional / TAS"],
  CHART_COLORS["Regional / NT"],
  CHART_COLORS["Regional / National"],
]

export function namedColor(index: number) {
  return NAMED_COLORS[index % NAMED_COLORS.length]
}

export function getAffordabilityColor(x: number, reverse?: boolean, faded?: boolean) {
  const opacity = faded ? "0.2" : "1"

  if (reverse) {
    if (x === 7) return `rgba(255, 244, 217, ${opacity})`
    if (x === 6) return `rgba(251, 229, 172, ${opacity})`
    if (x === 5) return `rgba(248, 213, 127, ${opacity})`
    if (x === 4) return `rgba(245, 198, 82, ${opacity})`
    if (x === 3) return `rgba(238, 177, 85, ${opacity})`
    if (x === 2) return `rgba(232, 157, 87, ${opacity})`
    if (x === 1) return `rgba(227, 138, 88, ${opacity})`
    if (x === 0) return `rgba(198, 46, 29, ${opacity})`
  } else {
    if (x === 0) return `rgba(255, 244, 217, ${opacity})`
    if (x === 1) return `rgba(251, 229, 172, ${opacity})`
    if (x === 2) return `rgba(248, 213, 127, ${opacity})`
    if (x === 3) return `rgba(245, 198, 82, ${opacity})`
    if (x === 4) return `rgba(238, 177, 85, ${opacity})`
    if (x === 5) return `rgba(232, 157, 87, ${opacity})`
    if (x === 6) return `rgba(227, 138, 88, ${opacity})`
    if (x === 7) return `rgba(198, 46, 29, ${opacity})`
  }
  return "#5E5E5E"
}

export function debounce<T extends (...args: any[]) => void>(func: T, wait: number): (...args: Parameters<T>) => void {
  let timeout: ReturnType<typeof setTimeout>
  return function (...args: Parameters<T>) {
    clearTimeout(timeout)
    timeout = setTimeout(() => func(...args), wait)
  }
}

export function calculateAngle(x: number, zero: number, maxValue: number, rangeRadians: number) {
  if (x < 0 || x > maxValue) {
    throw new Error("Value x is out of range")
  }

  const angle = zero + (x / maxValue) * rangeRadians
  return angle
}

export function generateArrayWithIntervals(number: number, interval: number) {
  // Calculate the next multiple of 'interval' greater than or equal to 'number'
  let maxValue = Math.ceil(number / interval) * interval

  let array = []
  for (let i = 0; i <= maxValue; i += interval) {
    array.push(i)
  }
  return array
}

export function getArrayPosition(haystack: any, needle: string) {
  return haystack.datasets[0].order.findIndex((x: string) => x === needle)
}

export function monthDiff(d1: Date, d2: Date) {
  if (isNaN(d1.getTime()) || isNaN(d2.getTime())) {
    return NaN // Or handle the error in another way
  }

  let months = (d2.getFullYear() - d1.getFullYear()) * 12
  months -= d1.getMonth()
  months += d2.getMonth()
  return months <= 0 ? 0 : months
}
